/**
 * ============================================================================
 * DOCUMENTS STORE - CACHE RETRIEVAL BY GAME
 * ============================================================================
 * 
 * Functions for retrieving cached documents filtered by game ID.
 * 
 * @module documents/cache/byGame
 */

import { documentStore } from "../store";
import type { DocumentItem } from "../types";

// ============================================================================
// CACHE RETRIEVAL BY GAME
// ============================================================================

/**
 * Get cached documents for a specific game.
 * 
 * Note: This reads from local cache. Call fetchDocumentItems() first to populate the cache.
 * 
 * @param gameId - The game ID to filter by
 * @returns Array of cached documents for the game
 * 
 * @example
 * ```ts
 * const documents = getCachedDocumentItems(gameId);
 * ```
 */
export function getCachedDocumentItems(gameId: string): DocumentItem[] {
  const allItems = documentStore.getData();
  return allItems.filter(item => item.game_id === gameId);
}
